'use strict';

function isUSLocale() {
    return $('#currentLocale').val() === 'en_US';
}

function onlyDigitsUSPhone(phoneInputValue) {
    if (!phoneInputValue) {
        return '';
    }

    var onlyDigitsPhoneInputValue = phoneInputValue.replace(/[^0-9]/g, '');
    return onlyDigitsPhoneInputValue.startsWith('1')
        ? onlyDigitsPhoneInputValue.substring(1)
        : onlyDigitsPhoneInputValue;
}

function validateUSPhoneCountryCode($phoneInput) {
    var phoneInputValue = $phoneInput.val();
    var phoneInputValueLength = phoneInputValue.length;

    if (!(isUSLocale() && phoneInputValueLength)) {
        return false;
    }

    var pattern = /^\+$|^(\+1)?[ 0-9\-()]*$/;
    return pattern.test(phoneInputValue);
}

function isValidUSPhone($phoneInput, compareFlag) {
    if (!$phoneInput) {
        return false;
    }

    var isValidUSPhoneCountryCode = validateUSPhoneCountryCode($phoneInput);
    var onlyDigitsUSPhoneLength = onlyDigitsUSPhone($phoneInput.val()).length;
    var maxlength = $phoneInput.data('maxlength');
    var compareLengths;

    switch (compareFlag) {
        case 'lt':
            compareLengths = onlyDigitsUSPhoneLength < maxlength;
            break;
        case 'lteq':
            compareLengths = onlyDigitsUSPhoneLength <= maxlength;
            break;
        case 'eq':
            compareLengths = onlyDigitsUSPhoneLength === maxlength;
            break;
        case 'gt':
            compareLengths = onlyDigitsUSPhoneLength > maxlength;
            break;
        case 'gteq':
            compareLengths = onlyDigitsUSPhoneLength >= maxlength;
            break;
        default:
            compareLengths = false;
    }

    return isValidUSPhoneCountryCode && compareLengths;
}

function formatPhoneNumber($phoneInput) {
    if ($phoneInput) {
        var pattern = $phoneInput.data('pattern');

        if (!pattern) {
            return;
        }

        var phoneInputValue = onlyDigitsUSPhone($phoneInput.val());

        if (phoneInputValue.length < $phoneInput.data('maxlength')) {
            return;
        }

        var phoneNumberFormatRegex = new RegExp(pattern);
        var match = phoneInputValue.match(phoneNumberFormatRegex);
        var formattedPhoneNumber = match
            ? match[1] + ' ' + match[2] + ' ' + match[3]
            : phoneInputValue;

        $phoneInput.val(formattedPhoneNumber);
    }
}

module.exports = {
    isUSLocale: isUSLocale,
    onlyDigitsUSPhone: onlyDigitsUSPhone,
    validateUSPhoneCountryCode: validateUSPhoneCountryCode,
    isValidUSPhone: isValidUSPhone,
    formatPhoneNumber: formatPhoneNumber
};
